import React from "react";
import ArrowUpIcon from "mdi-react/ChevronTripleUpIcon";
import ArrowDownIcon from "mdi-react/ChevronTripleDownIcon";
import FlatIcon from "mdi-react/MinusIcon";

export default ({ value, reverse }) => {
  const isPositive = value >= 0;
  return (
    <div className="semi-container">
      <div class="multigraph">
        <span class="graph"></span>
        <div className={`semiCircle_icon ${isPositive || (!isPositive && reverse) ? "upward" : "downward"}`}>
          {isPositive ? (
            <>
              <ArrowUpIcon size={36} /><span>{Math.abs(value)}%</span>
            </>
          ) : (
            <>
              <ArrowDownIcon size={36} /><span>{Math.abs(value)}%</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
